export default theme => ({
    tiivii_icon: {
        width: 24,
        height: 24
    },
    icon_radio_button: {
        margin: 12,
        color: theme.palette.primary.main,
    },
    icon_radio_button__selected: {
        color: theme.palette.userSecondary.main,
    },
    label: {
        marginLeft: 5,
        fontSize: theme.textSizes[1],
    },
});
